import { defineStore } from 'pinia';
import menusStore from '@/common/store/menus';

const useBreadcrumbStore = defineStore('breadcrumbStore', {
    state: () => ({
        list: [] // 面包屑
    }),
    actions: {
        setBreadcrumb(list) {
            this.list = list.map(item => ({
                name: item.meta.title,
                path: item.path
            }));
            const currentRouter = list[list.length - 1];
            // set isHiddenMenus
            menusStore().isHiddenMenus = currentRouter.meta && currentRouter.meta.isHiddenMenu;
        }
    }
});

export default useBreadcrumbStore;
